export function buildImageUrl(imagePath: string): string {
  if (imagePath.startsWith('blob:') || imagePath.startsWith('data:') || imagePath.startsWith('http')) {
    return imagePath
  }
  return `${import.meta.env.VITE_API_URL}/storage/${imagePath}`
}
